import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { PurchaseMissingItem } from 'apis/merchant-gateway/merchant-analytics/types';
import MonetaryAmount from 'common/formatting/MonetaryAmount';
import { useLocaleUtils } from 'common/hooks';
import { localize } from 'common/utils';

import {
  ItemCount,
  ItemInfo,
  ItemInfoRow,
  ItemName,
  ItemPrice,
  ItemRoot,
  MultiplicationSign,
} from './PurchaseBreakdown.styled';

const PurchaseMissingItem = ({ missingItem, currency }: { missingItem: PurchaseMissingItem; currency: Currency }) => {
  const { locale } = useIntl();
  const { formatWeightQuantity } = useLocaleUtils();

  const itemName = localize(missingItem.product.names, locale);

  return (
    <ItemRoot>
      <ItemInfo>
        <ItemInfoRow>
          {missingItem.weightedItem ? (
            <>
              {!!missingItem.weightedItem.weightInGrams && (
                <ItemCount>
                  {formatWeightQuantity(missingItem.weightedItem.weightInGrams, {
                    unitDisplay: 'narrow',
                  })}{' '}
                  <MultiplicationSign />
                </ItemCount>
              )}
              <ItemName>
                {itemName}
                {!!missingItem.weightedItem.requestedCount && (
                  <>
                    {' '}
                    (
                    <FormattedMessage
                      id="purchases.display-unit-pc"
                      values={{
                        unit: missingItem.weightedItem.requestedCount,
                      }}
                    />
                    )
                  </>
                )}
              </ItemName>
            </>
          ) : (
            <>
              <ItemCount>
                {missingItem.count} <MultiplicationSign />
              </ItemCount>{' '}
              <ItemName>{itemName}</ItemName>
            </>
          )}
          <ItemPrice>
            <MonetaryAmount amount={missingItem.finalPriceGross} currency={currency} />
          </ItemPrice>
        </ItemInfoRow>
      </ItemInfo>
    </ItemRoot>
  );
};

export default PurchaseMissingItem;
